"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPECIAL_OFFERS_LABELS = exports.SPECIAL_TAB_TO_TITLE_MAP = exports.PRODUCT_TAG_TO_SPECIAL_OFFERS_TABS_MAP = exports.EDUCATION_DEFAULT_TABS_ORDER = exports.INSURANCE_DEFAULT_TABS_ORDER = exports.MFO_DEFAULT_TABS_ORDER = exports.BANK_DEFAULT_TABS_ORDER = exports.ORGANIZATION_CARD_DEFAULT_TABS_ORDER = exports.OFFERS_TABS_DEFAULT_ORDER = exports.ALL_SPECIAL_TABS = exports.SPECIAL_VITRINS_TYPES_LIST = exports.SPECIAL_BUSINESS_TYPES_LIST = exports.SPECIAL_EDUCATION_TYPES_LIST = exports.SPECIAL_INSURANCE_TYPES_LIST_FROM_VITRINS = exports.SPECIAL_INSURANCE_TYPES_LIST = exports.SPECIAL_ACTION_TYPES_LIST = exports.SPECIAL_OFFER_TYPES_LIST = exports.SPECIAL_BUSINESS_TYPE = exports.SPECIAL_EDUCATION_TYPE = exports.SPECIAL_INSURANCE_TYPE_FROM_VITRINS = exports.SPECIAL_INSURANCE_TYPE = exports.SPECIAL_ACTION_TYPE = exports.SPECIAL_OFFER_TYPE = void 0;
var SPECIAL_OFFER_TYPE;
(function (SPECIAL_OFFER_TYPE) {
    SPECIAL_OFFER_TYPE["savings"] = "savings";
    SPECIAL_OFFER_TYPE["credits"] = "credits";
    SPECIAL_OFFER_TYPE["mortgage"] = "mortgage";
    SPECIAL_OFFER_TYPE["creditCards"] = "creditCards";
    SPECIAL_OFFER_TYPE["debitCards"] = "debitCards";
    SPECIAL_OFFER_TYPE["loan"] = "loan";
    SPECIAL_OFFER_TYPE["accumulative"] = "accumulative";
    SPECIAL_OFFER_TYPE["broker"] = "brokerskoeObsluzhivanie";
    SPECIAL_OFFER_TYPE["bankrotstvo"] = "bankrotstvo";
})(SPECIAL_OFFER_TYPE = exports.SPECIAL_OFFER_TYPE || (exports.SPECIAL_OFFER_TYPE = {}));
var SPECIAL_ACTION_TYPE;
(function (SPECIAL_ACTION_TYPE) {
    // none = 'none',
    SPECIAL_ACTION_TYPE["osago"] = "osago";
})(SPECIAL_ACTION_TYPE = exports.SPECIAL_ACTION_TYPE || (exports.SPECIAL_ACTION_TYPE = {}));
var SPECIAL_INSURANCE_TYPE;
(function (SPECIAL_INSURANCE_TYPE) {
    SPECIAL_INSURANCE_TYPE["insuranceOsago"] = "insuranceOsago";
    SPECIAL_INSURANCE_TYPE["dms"] = "dms";
    SPECIAL_INSURANCE_TYPE["strahovka-kriticheskie-bolezni"] = "strahovka-kriticheskie-bolezni";
    SPECIAL_INSURANCE_TYPE["strahovka-ot-klescha"] = "strahovka-ot-klescha";
    SPECIAL_INSURANCE_TYPE["strahovanie-domov"] = "strahovanie-domov";
})(SPECIAL_INSURANCE_TYPE = exports.SPECIAL_INSURANCE_TYPE || (exports.SPECIAL_INSURANCE_TYPE = {}));
var SPECIAL_INSURANCE_TYPE_FROM_VITRINS;
(function (SPECIAL_INSURANCE_TYPE_FROM_VITRINS) {
    SPECIAL_INSURANCE_TYPE_FROM_VITRINS["dms"] = "dms";
    SPECIAL_INSURANCE_TYPE_FROM_VITRINS["strahovka-kriticheskie-bolezni"] = "strahovka-kriticheskie-bolezni";
    SPECIAL_INSURANCE_TYPE_FROM_VITRINS["strahovka-ot-klescha"] = "strahovka-ot-klescha";
    SPECIAL_INSURANCE_TYPE_FROM_VITRINS["strahovanie-domov"] = "strahovanie-domov";
})(SPECIAL_INSURANCE_TYPE_FROM_VITRINS = exports.SPECIAL_INSURANCE_TYPE_FROM_VITRINS || (exports.SPECIAL_INSURANCE_TYPE_FROM_VITRINS = {}));
var SPECIAL_EDUCATION_TYPE;
(function (SPECIAL_EDUCATION_TYPE) {
    SPECIAL_EDUCATION_TYPE["programming"] = "programming";
})(SPECIAL_EDUCATION_TYPE = exports.SPECIAL_EDUCATION_TYPE || (exports.SPECIAL_EDUCATION_TYPE = {}));
var SPECIAL_BUSINESS_TYPE;
(function (SPECIAL_BUSINESS_TYPE) {
    SPECIAL_BUSINESS_TYPE["rko"] = "biznesRko";
    SPECIAL_BUSINESS_TYPE["kredity"] = "biznesKredity";
    SPECIAL_BUSINESS_TYPE["registration"] = "biznesRegistration";
    SPECIAL_BUSINESS_TYPE["ekvajring"] = "biznesEkvajring";
    SPECIAL_BUSINESS_TYPE["accounting"] = "biznesAccounting";
    SPECIAL_BUSINESS_TYPE["bankovskieGarantii"] = "bankovskieGarantii";
    SPECIAL_BUSINESS_TYPE["depozit"] = "biznesDepozit";
    SPECIAL_BUSINESS_TYPE["marketplace"] = "biznesMarketplace";
    SPECIAL_BUSINESS_TYPE["leasing"] = "biznesLeasing";
    SPECIAL_BUSINESS_TYPE["zarplatnyjProekt"] = "zarplatnyjProekt";
    SPECIAL_BUSINESS_TYPE["biznesVed"] = "biznes-ved";
})(SPECIAL_BUSINESS_TYPE = exports.SPECIAL_BUSINESS_TYPE || (exports.SPECIAL_BUSINESS_TYPE = {}));
exports.SPECIAL_OFFER_TYPES_LIST = Object.values(SPECIAL_OFFER_TYPE);
exports.SPECIAL_ACTION_TYPES_LIST = Object.values(SPECIAL_ACTION_TYPE);
exports.SPECIAL_INSURANCE_TYPES_LIST = Object.values(SPECIAL_INSURANCE_TYPE);
exports.SPECIAL_INSURANCE_TYPES_LIST_FROM_VITRINS = Object.values(SPECIAL_INSURANCE_TYPE_FROM_VITRINS);
exports.SPECIAL_EDUCATION_TYPES_LIST = Object.values(SPECIAL_EDUCATION_TYPE);
exports.SPECIAL_BUSINESS_TYPES_LIST = Object.values(SPECIAL_BUSINESS_TYPE);
exports.SPECIAL_VITRINS_TYPES_LIST = [
    ...exports.SPECIAL_OFFER_TYPES_LIST,
    ...exports.SPECIAL_EDUCATION_TYPES_LIST,
    ...exports.SPECIAL_BUSINESS_TYPES_LIST,
    ...exports.SPECIAL_INSURANCE_TYPES_LIST_FROM_VITRINS,
];
exports.ALL_SPECIAL_TABS = [
    ...exports.SPECIAL_OFFER_TYPES_LIST,
    ...exports.SPECIAL_ACTION_TYPES_LIST,
    ...exports.SPECIAL_EDUCATION_TYPES_LIST,
    ...exports.SPECIAL_BUSINESS_TYPES_LIST,
    ...exports.SPECIAL_INSURANCE_TYPES_LIST,
];
exports.OFFERS_TABS_DEFAULT_ORDER = [
    SPECIAL_OFFER_TYPE.loan,
    SPECIAL_OFFER_TYPE.creditCards,
    SPECIAL_OFFER_TYPE.savings,
    SPECIAL_OFFER_TYPE.debitCards,
    SPECIAL_OFFER_TYPE.credits,
    SPECIAL_OFFER_TYPE.mortgage,
    SPECIAL_OFFER_TYPE.broker,
    SPECIAL_BUSINESS_TYPE.rko,
    SPECIAL_OFFER_TYPE.accumulative,
    SPECIAL_BUSINESS_TYPE.kredity,
    SPECIAL_OFFER_TYPE.bankrotstvo,
    SPECIAL_EDUCATION_TYPE.programming,
    ...exports.SPECIAL_INSURANCE_TYPES_LIST,
];
exports.ORGANIZATION_CARD_DEFAULT_TABS_ORDER = [
    SPECIAL_OFFER_TYPE.credits,
    SPECIAL_OFFER_TYPE.creditCards,
    SPECIAL_OFFER_TYPE.savings,
    SPECIAL_OFFER_TYPE.debitCards,
    SPECIAL_OFFER_TYPE.mortgage,
    SPECIAL_BUSINESS_TYPE.rko,
    SPECIAL_OFFER_TYPE.accumulative,
    SPECIAL_OFFER_TYPE.broker,
    SPECIAL_OFFER_TYPE.bankrotstvo,
    SPECIAL_BUSINESS_TYPE.kredity,
    ...exports.SPECIAL_BUSINESS_TYPES_LIST,
    ...exports.SPECIAL_INSURANCE_TYPES_LIST_FROM_VITRINS,
].reduce((acc, tab) => (acc.includes(tab) ? acc : [...acc, tab]), []);
exports.BANK_DEFAULT_TABS_ORDER = exports.OFFERS_TABS_DEFAULT_ORDER.reduce((acc, tab) => {
    return acc.includes(tab) ? acc : [...acc, tab];
}, [SPECIAL_OFFER_TYPE.creditCards]);
exports.MFO_DEFAULT_TABS_ORDER = exports.OFFERS_TABS_DEFAULT_ORDER.reduce((acc, tab) => {
    return acc.includes(tab) ? acc : [...acc, tab];
}, [SPECIAL_OFFER_TYPE.loan]);
exports.INSURANCE_DEFAULT_TABS_ORDER = exports.OFFERS_TABS_DEFAULT_ORDER.reduce((acc, tab) => {
    return acc.includes(tab) ? acc : [...acc, tab];
}, exports.SPECIAL_INSURANCE_TYPES_LIST);
exports.EDUCATION_DEFAULT_TABS_ORDER = exports.OFFERS_TABS_DEFAULT_ORDER.reduce((acc, tab) => {
    return acc.includes(tab) ? acc : [...acc, tab];
}, [SPECIAL_EDUCATION_TYPE.programming]);
exports.PRODUCT_TAG_TO_SPECIAL_OFFERS_TABS_MAP = {
    vklady: [SPECIAL_OFFER_TYPE.savings, SPECIAL_OFFER_TYPE.accumulative],
    kredity: [SPECIAL_OFFER_TYPE.credits],
    'kredity/onlajn-zayavka-na-kredit': [SPECIAL_OFFER_TYPE.credits],
    'onlajn-zayavka-na-kredit': [SPECIAL_OFFER_TYPE.credits],
    ipoteka: [SPECIAL_OFFER_TYPE.mortgage],
    karty: [SPECIAL_OFFER_TYPE.creditCards, SPECIAL_OFFER_TYPE.debitCards],
    'debetovye-karty': [SPECIAL_OFFER_TYPE.debitCards],
    zaimy: [SPECIAL_OFFER_TYPE.loan],
    'zaimy/onlain': [SPECIAL_OFFER_TYPE.loan],
    'brokerskoe-obsluzhivanie': [SPECIAL_OFFER_TYPE.broker],
    'bankrotstvo': [SPECIAL_OFFER_TYPE.bankrotstvo],
    osago: [SPECIAL_INSURANCE_TYPE.insuranceOsago],
    dms: [SPECIAL_INSURANCE_TYPE.dms],
    'strahovka-kriticheskie-bolezni': [SPECIAL_INSURANCE_TYPE["strahovka-kriticheskie-bolezni"]],
    'strahovka-ot-klescha': [SPECIAL_INSURANCE_TYPE["strahovka-ot-klescha"]],
    'strahovanie-domov': [SPECIAL_INSURANCE_TYPE["strahovanie-domov"]],
    kursy: [SPECIAL_EDUCATION_TYPE.programming],
    rko: [SPECIAL_BUSINESS_TYPE.rko],
    'biznes-kredity': [SPECIAL_BUSINESS_TYPE.kredity],
    ekvajring: [SPECIAL_BUSINESS_TYPE.ekvajring],
    'bankovskie-garantii': [SPECIAL_BUSINESS_TYPE.bankovskieGarantii],
    'biznes-vklady': [SPECIAL_BUSINESS_TYPE.depozit],
    'biznes-registration': [SPECIAL_BUSINESS_TYPE.registration],
    'biznes-accounting': [SPECIAL_BUSINESS_TYPE.accounting],
    'biznes-marketplace': [SPECIAL_BUSINESS_TYPE.marketplace],
    'biznes-leasing': [SPECIAL_BUSINESS_TYPE.leasing],
    'zarplatnyj-proekt': [SPECIAL_BUSINESS_TYPE.zarplatnyjProekt],
    'ved': [SPECIAL_BUSINESS_TYPE.biznesVed],
};
exports.SPECIAL_TAB_TO_TITLE_MAP = {
    [SPECIAL_OFFER_TYPE.savings]: 'по вкладам',
    [SPECIAL_OFFER_TYPE.credits]: 'по кредитам',
    [SPECIAL_OFFER_TYPE.debitCards]: 'по дебетовым картам',
    [SPECIAL_OFFER_TYPE.creditCards]: 'по кредитным картам',
    [SPECIAL_OFFER_TYPE.mortgage]: 'по ипотеке',
    [SPECIAL_OFFER_TYPE.loan]: 'по займам',
    [SPECIAL_OFFER_TYPE.accumulative]: 'по накопительным счетам',
    [SPECIAL_OFFER_TYPE.broker]: 'по брокерскому обслуживанию',
    [SPECIAL_OFFER_TYPE.bankrotstvo]: 'по банкротству физических лиц',
    [SPECIAL_ACTION_TYPE.osago]: 'по осаго',
    [SPECIAL_INSURANCE_TYPE.insuranceOsago]: 'по страхованию ОСАГО',
    [SPECIAL_INSURANCE_TYPE.dms]: 'по добровольному медицинскому страхованию',
    [SPECIAL_INSURANCE_TYPE["strahovanie-domov"]]: 'по страхованию дома и дачи',
    [SPECIAL_INSURANCE_TYPE["strahovka-kriticheskie-bolezni"]]: 'по страхованию от критических заболеваний',
    [SPECIAL_INSURANCE_TYPE["strahovka-ot-klescha"]]: 'по страховке от укуса клеща',
    [SPECIAL_EDUCATION_TYPE.programming]: 'по программированию',
    [SPECIAL_BUSINESS_TYPE.registration]: 'по регистрации бизнеса',
    [SPECIAL_BUSINESS_TYPE.rko]: 'по РКО',
    [SPECIAL_BUSINESS_TYPE.kredity]: 'по кредитам для бизнеса',
    [SPECIAL_BUSINESS_TYPE.ekvajring]: 'по эквайрингу',
    [SPECIAL_BUSINESS_TYPE.accounting]: 'по ведению бухгалтерского учёта',
    [SPECIAL_BUSINESS_TYPE.bankovskieGarantii]: 'по банковским гарантиям',
    [SPECIAL_BUSINESS_TYPE.depozit]: 'по вкладам для бизнеса',
    [SPECIAL_BUSINESS_TYPE.marketplace]: 'по бизнесу на маркетплейсах',
    [SPECIAL_BUSINESS_TYPE.leasing]: 'по лизингу',
    [SPECIAL_BUSINESS_TYPE.zarplatnyjProekt]: 'по зарплатным проектам',
    [SPECIAL_BUSINESS_TYPE.biznesVed]: 'по ВЭД',
};
exports.SPECIAL_OFFERS_LABELS = {
    [SPECIAL_OFFER_TYPE.savings]: 'Вклады',
    [SPECIAL_OFFER_TYPE.accumulative]: 'Накопительные счета',
    [SPECIAL_OFFER_TYPE.credits]: 'Кредиты',
    [SPECIAL_OFFER_TYPE.mortgage]: 'Ипотека',
    [SPECIAL_OFFER_TYPE.creditCards]: 'Кредитные карты',
    [SPECIAL_OFFER_TYPE.debitCards]: 'Дебетовые карты',
    [SPECIAL_OFFER_TYPE.loan]: 'Займы',
    [SPECIAL_OFFER_TYPE.broker]: 'Брокерское обслуживание',
    [SPECIAL_OFFER_TYPE.bankrotstvo]: 'Банкротство физических лиц',
    [SPECIAL_ACTION_TYPE.osago]: 'Осаго',
    [SPECIAL_INSURANCE_TYPE.insuranceOsago]: 'Страхование ОСАГО',
    [SPECIAL_INSURANCE_TYPE.dms]: 'ДМС',
    [SPECIAL_INSURANCE_TYPE["strahovanie-domov"]]: 'Страхование домов',
    [SPECIAL_INSURANCE_TYPE["strahovka-kriticheskie-bolezni"]]: 'Страхование от критических заболеваний',
    [SPECIAL_INSURANCE_TYPE["strahovka-ot-klescha"]]: 'Страховка от укуса клеща',
    [SPECIAL_EDUCATION_TYPE.programming]: 'Курсы по программированию',
    [SPECIAL_BUSINESS_TYPE.registration]: 'Регистрация бизнеса',
    [SPECIAL_BUSINESS_TYPE.rko]: 'РКО',
    [SPECIAL_BUSINESS_TYPE.kredity]: 'Бизнес-кредиты',
    [SPECIAL_BUSINESS_TYPE.ekvajring]: 'Эквайринг',
    [SPECIAL_BUSINESS_TYPE.accounting]: 'Бухгалтерия для бизнеса',
    [SPECIAL_BUSINESS_TYPE.bankovskieGarantii]: 'Банковские гарантии',
    [SPECIAL_BUSINESS_TYPE.depozit]: 'Вклады для бизнеса',
    [SPECIAL_BUSINESS_TYPE.marketplace]: 'Бизнес на маркетплейсах',
    [SPECIAL_BUSINESS_TYPE.leasing]: 'Лизинг',
    [SPECIAL_BUSINESS_TYPE.zarplatnyjProekt]: 'Зарплатные проекты',
    [SPECIAL_BUSINESS_TYPE.biznesVed]: 'ВЭД',
};
